<template>
  <div class="space-y-5 divide-y divide-gray-900/10">
    <div class="grid grid-cols-1 gap-8 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <mdicon name="rotate-orbit" size="450" class="absolute -left-10 top-0 -z-10 text-slate-50" aria-hidden="true"></mdicon>
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">General</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Specify name, description and type for the Macro. Provide guidelines how to summarize conversation.</p>
        </div>
      </div>

      <form class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <div class="sm:col-span-4">
              <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Name</label>
              <div class="mt-2">
                <div class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                  <input
                    id="name"
                    v-model="specName"
                    type="text"
                    name="name"
                    class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Specify Macros Name"
                  />
                </div>
              </div>
            </div>

            <div class="col-span-full">
              <label for="description" class="block text-sm font-medium leading-6 text-gray-900">Description</label>
              <div class="mt-2">
                <textarea
                  id="description"
                  v-model="specDescription"
                  name="description"
                  rows="2"
                  class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div class="col-span-full">
              <label for="description" class="block text-sm font-medium leading-6 text-gray-900">Type</label>
              <div class="mt-2 text-md font-source font-medium leading-6 text-gray-900">Summarize</div>
            </div>

            <div class="col-span-full">
              <div class="">
                <InputTextarea
                  v-model="summarizeGuidelines"
                  class="col-span-full mt-4"
                  name="guardrailsGuidelines"
                  :label="propsDefs['summarizeGuidelines'].title"
                  :description="propsDefs['summarizeGuidelines'].description"
                  :placeholder="propsDefs['summarizeGuidelines'].placeholder"
                  :rows="8"
                ></InputTextarea>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
  import { computed, onMounted, ref, watch } from 'vue';
  import InputTextarea from '@/components/Bots/editors/InputTextarea.vue';

  const props = defineProps({
    specData: {
      type: Object,
      default() {
        return {};
      },
    },
    advanced: {
      type: Boolean,
      default: false,
    },
    action: {
      type: Object,
      default() {
        return {};
      },
    },
  });
  const emit = defineEmits(['update:advanced', 'update:specProp', 'update:specScriptStepProp']);
  const defs = [
    {
      name: 'summarizeGuidelines',
      advanced: false,
      type: 'text',
      title: 'Summarize Guidelines',
      default: '',
      description: 'Provide guidelines for Summarizing conversation. You may describe what to include, what should be the format, how long it should be. Keep blank for default behavior.',
    },
  ];

  const propsDefs = {};

  defs.map((p) => {
    const pD = {
      type: p?.type || '',
      title: p?.title || '',
      description: p?.description || '',
      default: p?.default || '',
      placeholder: p?.placeholder || '',
    };
    propsDefs[p.name] = pD;
  });

  const specName = computed({
    get() {
      return props.specData?.name;
    },
    set(newValue) {
      emit('update:specProp', 'name', newValue);
    },
  });

  const specDescription = computed({
    get() {
      return props.specData?.description;
    },
    set(newValue) {
      emit('update:specProp', 'description', newValue);
    },
  });

  const summarizeGuidelines = computed({
    get() {
      return props.specData?.summarizeGuidelines;
    },
    set(newValue) {
      emit('update:specProp', 'summarizeGuidelines', newValue);
    },
  });
</script>
